import styled from 'styled-components'
import { css } from 'styled-components'
import { font } from '../vars/font.style'
import { clamp } from '../utils/conversion.style'

export const textStylesConfig = {
  super: {
    family: font.heading.family,
    weight: font.heading.weight.medium,
    size: {
      min: 72,
      max: 140,
    },
    lineHeight: 0.9,
    letterSpacing: -0.02,
    uppercase: true,
  },
  heading1: {
    family: font.heading.family,
    weight: font.heading.weight.medium,
    size: {
      min: 42,
      max: 140,
    },
    lineHeight: 0.9,
    letterSpacing: -0.02,
    uppercase: true,
  },
  heading2: {
    family: font.heading.family,
    weight: font.heading.weight.medium,
    size: {
      min: 42,
      max: 80,
    },
    lineHeight: 1.1,
    letterSpacing: -0.02,
    uppercase: true,
  },
  heading3: {
    family: font.heading.family,
    weight: font.heading.weight.medium,
    size: {
      min: 42,
      max: 58,
    },
    lineHeight: 1.1,
    letterSpacing: -0.02,
    uppercase: true,
  },
  heading4: {
    family: font.heading.family,
    weight: font.heading.weight.medium,
    size: {
      min: 24,
      max: 36,
    },
    lineHeight: 1.1,
    letterSpacing: -0.01,
    uppercase: true,
  },
  title: {
    family: font.primary.family,
    weight: font.primary.weight.regular,
    size: {
      min: 16,
      max: 24,
    },
    lineHeight: 1.35,
    letterSpacing: -0.01,
  },
  body: {
    family: font.primary.family,
    weight: font.primary.weight.regular,
    size: {
      min: 16,
      max: 20,
    },
    lineHeight: 1.5,
    letterSpacing: -0.01,
  },
  cta: {
    family: font.primary.family,
    weight: font.primary.weight.medium,
    size: {
      min: 12,
      max: 16,
    },
    lineHeight: 1.205,
    uppercase: true,
  },
  label: {
    family: font.primary.family,
    weight: font.primary.weight.medium,
    size: {
      min: 12,
      max: 14,
    },
    lineHeight: 1.205,
    uppercase: true,
  },
}

export const getStyles = style => `
  font-family: ${style.family};
  font-weight: ${style.weight};
  line-height: ${style.lineHeight};
  ${style.letterSpacing ? `letter-spacing: ${style.letterSpacing}em` : ''};
  ${clamp('font-size', style.size.min, style.size.max)}
  ${style.uppercase ? 'text-transform: uppercase' : ''};

  i.sup {
    display: inline-block;
    font-style: normal;
  }
`

const headingStyles = style => `
  em,
  span.em {
    font-family: ${font.headingAlt.family};
    font-size: 86.5%;
    font-style: normal;
    line-height: 1;
    text-transform: none;
    white-space: nowrap;
  }
`

const SuperStyles = css`
  ${getStyles(textStylesConfig.super)}
  ${headingStyles}
`

const Heading1Styles = css`
  ${getStyles(textStylesConfig.heading1)}
  ${headingStyles}
`

const Heading2Styles = css`
  ${getStyles(textStylesConfig.heading2)}
  ${headingStyles}
`

const Heading3Styles = css`
  ${getStyles(textStylesConfig.heading3)}
  ${headingStyles}
`

const Heading4Styles = css`
  ${getStyles(textStylesConfig.heading4)}
`

const TitleStyles = css`
  ${getStyles(textStylesConfig.title)}
`

const TextBodyStyles = css`
  ${getStyles(textStylesConfig.body)}
`

export const CtaStyles = css`
  ${getStyles(textStylesConfig.cta)}
`

const LabelStyles = css`
  ${getStyles(textStylesConfig.label)}
`

export const Super = styled.p`
  max-width: ${props => (props.maxWidth ? `${props.maxWidth}em` : undefined)};
  ${SuperStyles}
  color: ${props => (props.color ? props.color : undefined)};
`

export const Heading1 = styled.p`
  max-width: ${props => (props.maxWidth ? `${props.maxWidth}em` : undefined)};
  ${Heading1Styles}
  color: ${props => (props.color ? props.color : undefined)};
`

export const Heading2 = styled.p`
  max-width: ${props => (props.maxWidth ? `${props.maxWidth}em` : undefined)};
  ${Heading2Styles}
  color: ${props => (props.color ? props.color : undefined)};
`

export const Heading3 = styled.p`
  max-width: ${props => (props.maxWidth ? `${props.maxWidth}em` : undefined)};
  ${Heading3Styles}
  color: ${props => (props.color ? props.color : undefined)};
`

export const Heading4 = styled.p`
  max-width: ${props => (props.maxWidth ? `${props.maxWidth}em` : undefined)};
  ${Heading4Styles}
  color: ${props => (props.color ? props.color : undefined)};
`

export const Title = styled.p`
  max-width: ${props => (props.maxWidth ? `${props.maxWidth}em` : undefined)};
  ${TitleStyles}
  color: ${props => (props.color ? props.color : undefined)};
`

export const TextBody = styled.p`
  max-width: ${props => (props.maxWidth ? `${props.maxWidth}em` : undefined)};
  ${TextBodyStyles}
  color: ${props => (props.color ? props.color : undefined)};
`

export const Cta = styled.span`
  max-width: ${props => (props.maxWidth ? `${props.maxWidth}em` : undefined)};
  ${CtaStyles}
  color: ${props => (props.color ? props.color : undefined)};
  text-transform: ${props =>
    props.textTransform ? props.textTransform : undefined};
`

export const Label = styled.p`
  max-width: ${props => (props.maxWidth ? `${props.maxWidth}em` : undefined)};
  ${LabelStyles}
  color: ${props => (props.color ? props.color : undefined)};

  ${props =>
    props.bgColor &&
    `
    background-color: ${props.bgColor};
    border-radius: 0.3rem;
    display: inline-block;
    padding: 0.2rem 0.5rem;
  `}
`
